import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Grid,
  Card,
  CardContent,
  Box,
  Paper,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  IconButton,
  Collapse,
  Fab
} from '@mui/material';
import {
  Pets as PetsIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  LocalHospital as HospitalIcon,
  Vaccines as VaccinesIcon,
  MedicalServices as TreatmentIcon,
  MedicalServices as MedicalIcon,
  WhatsApp as WhatsAppIcon,
  Home as HomeIcon,
  Schedule as ScheduleIcon,
  Security as SecurityIcon,
  Favorite as FavoriteIcon,
  CheckCircle as CheckIcon,
  AccessTime as TimeIcon,
  HealthAndSafety as HealthIcon,
  Menu as MenuIcon,
  ExpandLess as ExpandLessIcon,
  Info as InfoIcon,
  ContactPhone as ContactIcon,
  Instagram as InstagramIcon,
  Medication as MedicationIcon,
  Flight as FlightIcon,
  Storefront as PetshopIcon
} from '@mui/icons-material';

const Servicios = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    const handleClickOutside = (event) => {
      if (mobileMenuOpen && !event.target.closest('.mobile-menu')) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  const serviciosDetallados = [
    {
      titulo: 'Consulta médica general',
      descripcion: 'Evaluación completa del estado de salud de tu mascota con examen físico detallado, diagnóstico y recomendaciones profesionales.',
      icono: <HospitalIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Desde $40.000',
      incluye: ['Examen físico completo', 'Diagnóstico preliminar', 'Recomendaciones de tratamiento', 'Plan de seguimiento'],
      duracion: '45-60 minutos'
    },
    {
      titulo: 'Programa de vacunación',
      descripcion: 'Esquema completo de vacunación según la edad y especie, incluyendo vacunas básicas y adicionales para protección integral.',
      icono: <VaccinesIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Variable',
      incluye: ['Vacunas básicas obligatorias', 'Vacunas opcionales', 'Cartilla de vacunación', 'Recordatorios automáticos'],
      duracion: '30 minutos'
    },
    {
      titulo: 'Desparasitación integral',
      descripcion: 'Eliminación y prevención de parásitos internos y externos con productos de última generación y seguimiento profesional.',
      icono: <MedicalIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Desde $20.000',
      incluye: ['Desparasitante interno', 'Tratamiento externo', 'Plan preventivo', 'Control post-tratamiento'],
      duracion: '20-30 minutos'
    },
    {
      titulo: 'Exámenes de laboratorio',
      descripcion: 'Toma de muestras y análisis clínicos especializados para diagnósticos precisos y control de tratamientos.',
      icono: <TreatmentIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Variable',
      incluye: ['Toma de muestras', 'Análisis especializados', 'Interpretación de resultados', 'Recomendaciones'],
      duracion: '15-30 minutos'
    },
    {
      titulo: 'Tratamiento ambulatorio',
      descripcion: 'Aplicación de medicamentos, curaciones, seguimientos terapéuticos y/o hospitalización en casa.',
      icono: <HealthIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Variable',
      incluye: ['Aplicación de medicamentos', 'Curaciones especializadas', 'Seguimiento terapéutico', 'Monitoreo de evolución'],
      duracion: '30-45 minutos'
    },
    {
      titulo: 'Certificado de viajes nacionales',
      descripcion: 'Expedición del certificado médico veterinario requerido para viajar con tu mascota dentro del país, con examen clínico y revisión de su esquema sanitario.',
      icono: <FlightIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Variable',
      incluye: ['Examen clínico previo', 'Verificación de vacunas', 'Verificación de desparasitación', 'Certificado firmado por la profesional'],
      duracion: '30-45 minutos'
    },
    {
      titulo: 'Eutanasia compasiva',
      descripcion: 'Acompañamiento respetuoso y libre de dolor en el momento de la despedida, con asesoría previa y apoyo a la familia durante todo el proceso.',
      icono: <FavoriteIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Variable',
      incluye: ['Asesoría previa a la familia', 'Sedación sin dolor', 'Procedimiento en casa', 'Orientación posterior'],
      duracion: '45-60 minutos'
    },
    {
      titulo: 'Venta de medicamentos veterinarios',
      descripcion: 'Suministro de medicamentos, antiparasitarios y suplementos de uso veterinario, formulados y dosificados según el tratamiento de tu mascota.',
      icono: <MedicationIcon fontSize="large" sx={{ color: '#c46494' }} />,
      precio: 'Variable',
      incluye: ['Medicamentos formulados', 'Antiparasitarios y suplementos', 'Dosificación personalizada', 'Indicaciones de administración'],
      duracion: 'Entrega inmediata'
    }
  ];

  const renderServicioCard = (servicio) => (
    <Card 
      sx={{ 
        height: '100%',
        width: '100%',
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': { 
          transform: { xs: 'none', sm: 'translateY(-2px)' },
          boxShadow: { xs: 2, sm: 4 }
        },
        border: '1px solid #fcdcf4',
        maxWidth: { xs: 'none', sm: '350px', md: '380px' },
        mx: 'auto'
      }}
    >
      <CardContent sx={{ 
        p: { xs: 1.5, sm: 2, md: 2.5 }, 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column' 
      }}>
        <Box sx={{ textAlign: 'center', mb: { xs: 1, sm: 1.5, md: 2 } }}>
          {servicio.icono}
        </Box>
        
        <Typography 
          variant="h6" 
          gutterBottom 
          fontWeight="bold" 
          sx={{ 
            color: '#602442', 
            textAlign: 'center', 
            mb: { xs: 1, sm: 1.5 }, 
            minHeight: { xs: '2.5rem', sm: '3rem', md: '4.5rem' }, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
            lineHeight: 1.2
          }}
        >
          {servicio.titulo}
        </Typography>
        
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#602442', 
            mb: { xs: 1.5, sm: 2 }, 
            lineHeight: 1.4, 
            textAlign: 'center', 
            minHeight: { xs: '5rem', sm: '7rem', md: '9rem' }, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
          }}
        >
          {servicio.descripcion}
        </Typography>
        
        <Box sx={{ 
          flex: 1,
          minHeight: { xs: '8rem', sm: '9rem', md: '10rem' },
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Typography 
            variant="subtitle2" 
            gutterBottom 
            sx={{ 
              color: '#a55e88', 
              fontWeight: 'bold', 
              textAlign: 'center', 
              mb: { xs: 1, sm: 1.5 },
              fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
            }}
          >
            Incluye:
          </Typography>
          <List dense sx={{ px: 0, flex: 1 }}>
            {servicio.incluye.map((item, idx) => (
              <ListItem key={idx} sx={{ py: 0.1, pl: 0, pr: 0 }}>
                <ListItemIcon sx={{ minWidth: { xs: 16, sm: 18 } }}>
                  <CheckIcon sx={{ 
                    color: '#c46494', 
                    fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.9rem' }
                  }} />
                </ListItemIcon>
                <ListItemText 
                  primary={item} 
                  sx={{ 
                    '& .MuiListItemText-primary': { 
                      fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' },
                      color: '#602442',
                      lineHeight: 1.3
                    } 
                  }} 
                />
              </ListItem>
            ))}
          </List>
        </Box>
        
        <Divider sx={{ my: { xs: 1, sm: 1.5 } }} />
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          px: 0,
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: 0.5, sm: 0 }
        }}>
          <Chip 
            label={servicio.precio} 
            sx={{ 
              backgroundColor: '#c9aebc', 
              color: '#602442',
              fontWeight: 'bold',
              fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' },
              height: { xs: 24, sm: 28 }
            }}
          />
          <Typography 
            variant="caption" 
            sx={{ 
              color: '#a55e88', 
              fontWeight: 500,
              fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' },
              textAlign: 'center'
            }}
          >
            {servicio.duracion}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );

  const razonesConsulta = [
    {
      titulo: 'Comodidad para tu mascota',
      descripcion: 'Evita el estrés del transporte y la sala de espera. Tu mascota se siente más tranquila en su entorno familiar.',
      icono: <HomeIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Ahorro de tiempo',
      descripcion: 'No necesitas desplazarte ni hacer filas. Agendamos la cita que mejor se adapte a tu horario.',
      icono: <TimeIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Atención personalizada',
      descripcion: 'Dedicamos tiempo exclusivo a tu mascota sin las distracciones de una clínica tradicional.',
      icono: <FavoriteIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Seguridad sanitaria',
      descripcion: 'Reduces el riesgo de contagio de enfermedades que pueden transmitirse en espacios cerrados.',
      icono: <SecurityIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Mascotas nerviosas o agresivas',
      descripcion: 'Ideal para animales que se estresan en ambientes desconocidos o tienen comportamientos difíciles.',
      icono: <PetsIcon fontSize="large" sx={{ color: '#c46494' }} />
    },
    {
      titulo: 'Múltiples mascotas',
      descripcion: 'Conveniente cuando tienes varias mascotas que necesitan atención médica simultánea.',
      icono: <ScheduleIcon fontSize="large" sx={{ color: '#c46494' }} />
    }
  ];

  const renderRazonCard = (razon) => (
    <Card 
      sx={{ 
        height: '100%', 
        width: '100%',
        textAlign: 'center',
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': { 
          transform: { xs: 'none', sm: 'translateY(-2px)' },
          boxShadow: { xs: 2, sm: 4 }
        },
        border: '2px solid #fcdcf4',
        maxWidth: { xs: 'none', sm: '320px', md: '350px' },
        mx: 'auto'
      }}
    >
      <CardContent sx={{ 
        p: { xs: 1.5, sm: 2, md: 3 }, 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column' 
      }}>
        <Box sx={{ mb: { xs: 1, sm: 2 } }}>
          {razon.icono}
        </Box>
        <Typography 
          variant="h6" 
          gutterBottom 
          fontWeight="bold" 
          sx={{ 
            color: '#602442', 
            mb: { xs: 1, sm: 1.5 }, 
            minHeight: { xs: '2rem', sm: '3rem', md: '3.5rem' }, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
            textAlign: 'center'
          }}
        >
          {razon.titulo}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#602442', 
            lineHeight: 1.5, 
            flex: 1, 
            minHeight: { xs: '4rem', sm: '5rem', md: '6rem' },
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            textAlign: 'center',
            fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' }
          }}
        >
          {razon.descripcion}
        </Typography>
      </CardContent>
    </Card>
  );

  const ventajasElegirnos = [
    'Veterinarios certificados con amplia experiencia',
    'Equipos médicos portátiles de última tecnología',
    'Precios competitivos y transparentes',
    'Seguimiento post-consulta incluido',
    'Medicamentos de alta calidad',
    'Historial médico digital de tu mascota',
    'Recordatorios automáticos de citas',
    'Cobertura en toda la ciudad'
  ];

  return (
    <Box>
      {/* Header/Navbar */}
      <AppBar 
        position="fixed" 
        sx={{ 
          backgroundColor: scrolled ? 'rgba(252, 220, 244, 0.95)' : 'transparent',
          backdropFilter: scrolled ? 'blur(10px)' : 'none',
          boxShadow: scrolled ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
          zIndex: 1100,
          transition: 'all 0.3s ease'
        }}
      >
        <Toolbar sx={{ py: { xs: 0.5, sm: 1 }, px: { xs: 1, sm: 2 } }}>
          <Box 
            sx={{ 
              mr: { xs: 1, sm: 2, md: 4 }, 
              display: 'flex', 
              alignItems: 'center',
              cursor: 'pointer',
              flexShrink: 0
            }}
            onClick={() => navigate('/')}
          >
            <img 
              src="/logo.png" 
              alt="Belkysvet Logo" 
              style={{ 
                height: window.innerWidth < 600 ? '40px' : window.innerWidth < 900 ? '50px' : '60px', 
                width: 'auto',
                maxWidth: window.innerWidth < 600 ? '100px' : '200px',
                marginRight: window.innerWidth < 600 ? '4px' : '8px'
              }} 
            />
            <Typography 
              variant="h5" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem' },
                display: { xs: 'none', sm: 'block' },
                textShadow: scrolled ? 'none' : '2px 2px 4px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
            >
              belkysveterinaria
            </Typography>
          </Box>
          
          {/* Spacer para empujar los botones a la derecha en móvil */}
          <Box sx={{ flexGrow: 1 }} />
          
          {/* Menú de navegación para desktop */}
          <Box sx={{ 
            display: { xs: 'none', md: 'flex' }, 
            gap: { md: 2, lg: 4 },
            mr: 2
          }}>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/')}
            >
              Inicio
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)',
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
            >
              Servicios
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/nosotros')}
            >
              Nosotros
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/petshop')}
            >
              Petshop
            </Button>
            <Button 
              color="inherit" 
              sx={{ 
                color: scrolled ? '#602442' : 'white', 
                fontWeight: 'bold',
                fontSize: { md: '1rem', lg: '1.1rem' },
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                px: { md: 1, lg: 2 },
                textShadow: scrolled ? 'none' : '1px 1px 2px rgba(0,0,0,0.8)',
                transition: 'all 0.3s ease'
              }}
              onClick={() => navigate('/contactos')}
            >
              Contacto
            </Button>
          </Box>

          {/* Botón de menú móvil */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              color="inherit"
              aria-label="menu"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              sx={{ 
                color: scrolled ? '#602442' : 'white',
                '&:hover': { 
                  backgroundColor: scrolled ? 'rgba(96, 36, 66, 0.1)' : 'rgba(255, 255, 255, 0.2)' 
                },
                transition: 'all 0.3s ease'
              }}
            >
              {mobileMenuOpen ? <ExpandLessIcon /> : <MenuIcon />}
            </IconButton>
          </Box>
        </Toolbar>

        {/* Menú móvil desplegable */}
        <Collapse in={mobileMenuOpen}>
          <Box sx={{ 
            backgroundColor: 'rgba(252, 220, 244, 0.98)',
            borderTop: '1px solid rgba(96, 36, 66, 0.1)',
            py: 1
          }}>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/');
                setMobileMenuOpen(false);
              }}
            >
              <HomeIcon sx={{ mr: 2 }} />
              Inicio
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                backgroundColor: 'rgba(96, 36, 66, 0.1)'
              }}
            >
              <MedicalIcon sx={{ mr: 2 }} />
              Servicios
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/nosotros');
                setMobileMenuOpen(false);
              }}
            >
              <InfoIcon sx={{ mr: 2 }} />
              Nosotros
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/petshop');
                setMobileMenuOpen(false);
              }}
            >
              <PetshopIcon sx={{ mr: 2 }} />
              Petshop
            </Button>
            <Button 
              fullWidth
              color="inherit" 
              sx={{ 
                color: '#602442', 
                fontWeight: 'bold',
                justifyContent: 'flex-start',
                px: 3,
                py: 1.5,
                '&:hover': { backgroundColor: 'rgba(96, 36, 66, 0.1)' }
              }}
              onClick={() => {
                navigate('/contactos');
                setMobileMenuOpen(false);
              }}
            >
              <ContactIcon sx={{ mr: 2 }} />
              Contactos
            </Button>
          </Box>
        </Collapse>
      </AppBar>

      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: {
            xs: 'linear-gradient(rgba(196, 100, 148, 0.8), rgba(96, 36, 66, 0.8)), url("/servicios.jpg")',
            md: 'linear-gradient(rgba(196, 100, 148, 0.7), rgba(96, 36, 66, 0.7)), url("/servicios.jpg")'
          },
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: { xs: 'scroll', md: 'fixed' },
          color: 'white',
          py: { xs: 4, sm: 6, md: 8 },
          px: { xs: 2, sm: 3 },
          textAlign: 'center',
          minHeight: { xs: '70vh', sm: '60vh', md: '60vh' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: { xs: '80px', sm: '90px', md: '100px' }
        }}
      >
        <Container maxWidth="md">
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom 
            fontWeight="bold"
            sx={{ 
              textShadow: '3px 3px 6px rgba(0,0,0,0.8)',
              fontSize: { xs: '1.6rem', sm: '2.2rem', md: '3.5rem' },
              lineHeight: { xs: 1.1, sm: 1.2, md: 1.3 },
              mb: { xs: 1.5, sm: 2, md: 3 },
              px: { xs: 1, sm: 0 }
            }}
          >
            Nuestros Servicios Veterinarios
          </Typography>
          <Typography 
            variant="h5" 
            sx={{ 
              mb: { xs: 2, sm: 3, md: 4 }, 
              opacity: 0.95,
              textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
              fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.5rem' },
              lineHeight: { xs: 1.3, sm: 1.4, md: 1.5 },
              px: { xs: 2, sm: 3 }
            }}
          >
            Atención profesional a domicilio para el bienestar de tu mascota
          </Typography>
        </Container>
      </Box>

      {/* Cuándo recurrir a consulta a domicilio */}
      <Container maxWidth="lg" sx={{ py: { xs: 3, sm: 5, md: 6 }, px: { xs: 1.5, sm: 3 } }}>
        <Typography 
          variant="h3" 
          align="center" 
          gutterBottom 
          sx={{ 
            color: '#602442',
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            mb: { xs: 1.5, sm: 2, md: 3 },
            px: { xs: 1, sm: 0 }
          }} 
          fontWeight="bold"
        >
          ¿Cuándo elegir consulta a domicilio?
        </Typography>
        <Typography 
          variant="h6" 
          align="center" 
          sx={{ 
            color: '#a55e88', 
            mb: { xs: 3, sm: 4, md: 5 },
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
            px: { xs: 2, sm: 3 },
            lineHeight: 1.4
          }}
        >
          Conoce las ventajas de nuestro servicio veterinario en la comodidad de tu hogar
        </Typography>
        
        {isMobile ? (
          <Box>
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                overflowX: 'auto',
                scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch',
                pb: 2,
                px: 0.5,
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': { display: 'none' }
              }}
            >
              {razonesConsulta.map((razon, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: '0 0 82%',
                    maxWidth: '82%',
                    scrollSnapAlign: 'center',
                    display: 'flex'
                  }}
                >
                  {renderRazonCard(razon)}
                </Box>
              ))}
            </Box>
            <Typography
              variant="caption"
              align="center"
              sx={{ display: 'block', mt: 1, color: '#a55e88' }}
            >
              Desliza para ver todas las ventajas
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }} justifyContent="center">
            {razonesConsulta.map((razon, index) => (
              <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex' }}>
                {renderRazonCard(razon)}
              </Grid>
            ))}
          </Grid>
        )}
      </Container>

      {/* Por qué elegirnos */}
      <Box sx={{ backgroundColor: '#fcdcf4', py: { xs: 3, sm: 4, md: 5 }, px: { xs: 1.5, sm: 3 } }}>
        <Container maxWidth="xl">
          <Typography 
            variant="h3" 
            align="center" 
            gutterBottom 
            sx={{ 
              color: '#602442',
              fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
              mb: { xs: 1.5, sm: 2, md: 3 },
              px: { xs: 1, sm: 0 }
            }} 
            fontWeight="bold"
          >
            ¿Por qué elegir Belkysveterinaria?
          </Typography>
          <Typography 
            variant="h6" 
            align="center" 
            sx={{ 
              color: '#a55e88', 
              mb: { xs: 2.5, sm: 3, md: 3.5 },
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
              px: { xs: 2, sm: 3 },
              lineHeight: 1.4
            }}
          >
            Somos líderes en atención veterinaria a domicilio
          </Typography>
          
          <Grid container spacing={{ xs: 2, sm: 3 }} justifyContent="center" alignItems="stretch">
            <Grid item xs={12} md={6} xl={5}>
              <Paper sx={{ 
                p: { xs: 2, sm: 2.5, md: 3 }, 
                height: '100%', 
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white', 
                boxShadow: 3, 
                maxWidth: { xs: 'none', md: '550px' }, 
                mx: 'auto' 
              }}>
                <Typography 
                  variant="h5" 
                  gutterBottom 
                  fontWeight="bold" 
                  sx={{ 
                    color: '#602442', 
                    mb: { xs: 1.5, sm: 2 }, 
                    textAlign: 'center',
                    fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.5rem' }
                  }}
                >
                  Nuestras Ventajas
                </Typography>
                <Grid container spacing={0.5} sx={{ flexGrow: 1, alignContent: 'center' }}>
                  {ventajasElegirnos.map((ventaja, index) => (
                    <Grid item xs={12} sm={6} md={12} lg={6} key={index}>
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', py: 0.5 }}>
                        <CheckIcon sx={{ 
                          color: '#c46494', 
                          fontSize: { xs: '0.9rem', sm: '1rem' }, 
                          mt: 0.1, 
                          mr: { xs: 1, sm: 1.2 }, 
                          flexShrink: 0 
                        }} />
                        <Typography 
                          variant="body2"
                          sx={{ 
                            color: '#602442', 
                            fontWeight: 500,
                            fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.85rem' },
                            lineHeight: 1.3,
                            textAlign: 'justify'
                          }}
                        >
                          {ventaja}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
            
            <Grid item xs={12} md={6} xl={5}>
              <Paper sx={{ 
                p: { xs: 2, sm: 2.5, md: 3 }, 
                height: '100%', 
                backgroundColor: 'white', 
                boxShadow: 3, 
                maxWidth: { xs: 'none', md: '550px' }, 
                mx: 'auto' 
              }}>
                <Typography 
                  variant="h5" 
                  gutterBottom 
                  fontWeight="bold" 
                  sx={{ 
                    color: '#602442', 
                    mb: { xs: 1.5, sm: 2 }, 
                    textAlign: 'center',
                    fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.5rem' }
                  }}
                >
                  Nuestro Compromiso
                </Typography>
                <Box>
                  <Typography 
                    variant="body2" 
                    paragraph 
                    sx={{ 
                      color: '#602442', 
                      lineHeight: 1.5, 
                      textAlign: 'justify', 
                      fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' }, 
                      mb: 1.5 
                    }}
                  >
                    En Belkysveterinaria nos comprometemos a brindar la mejor atención médica para tu mascota, 
                    combinando la experiencia profesional con el amor y cuidado que tu compañero peludo merece.
                  </Typography>
                  <Typography 
                    variant="body2" 
                    paragraph 
                    sx={{ 
                      color: '#602442', 
                      lineHeight: 1.5, 
                      textAlign: 'justify', 
                      fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' }, 
                      mb: 1.5 
                    }}
                  >
                    Nuestro equipo de veterinarios certificados cuenta con años de experiencia y se mantiene 
                    actualizado con las últimas técnicas y tratamientos veterinarios.
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: '#602442', 
                      lineHeight: 1.5, 
                      textAlign: 'justify', 
                      fontSize: { xs: '0.8rem', sm: '0.85rem', md: '0.9rem' }
                    }}
                  >
                    Utilizamos equipos médicos portátiles de última generación para garantizar diagnósticos 
                    precisos y tratamientos efectivos en la comodidad de tu hogar.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Servicios detallados */}
      <Container maxWidth="lg" sx={{ py: { xs: 3, sm: 5, md: 6 }, px: { xs: 1.5, sm: 3 } }}>
        <Typography 
          variant="h3" 
          align="center" 
          gutterBottom 
          sx={{ 
            color: '#602442',
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            mb: { xs: 1.5, sm: 2, md: 3 },
            px: { xs: 1, sm: 0 }
          }} 
          fontWeight="bold"
        >
          Servicios Que Ofrecemos
        </Typography>
        <Typography 
          variant="h6" 
          align="center" 
          sx={{ 
            color: '#a55e88', 
            mb: { xs: 3, sm: 4, md: 5 },
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
            px: { xs: 2, sm: 3 },
            lineHeight: 1.4
          }}
        >
          Atención integral para la salud y bienestar de tu mascota
        </Typography>
        
        {isMobile ? (
          <Box>
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                overflowX: 'auto',
                scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch',
                pb: 2,
                px: 0.5,
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': { display: 'none' }
              }}
            >
              {serviciosDetallados.map((servicio, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: '0 0 85%',
                    maxWidth: '85%',
                    scrollSnapAlign: 'center',
                    display: 'flex'
                  }}
                >
                  {renderServicioCard(servicio)}
                </Box>
              ))}
            </Box>
            <Typography
              variant="caption"
              align="center"
              sx={{ display: 'block', mt: 1, color: '#a55e88' }}
            >
              Desliza para ver todos los servicios
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={{ xs: 1.5, sm: 2, md: 3 }} justifyContent="center">
            {serviciosDetallados.map((servicio, index) => (
              <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: 'flex' }}>
                {renderServicioCard(servicio)}
              </Grid>
            ))}
          </Grid>
        )}
      </Container>

      {/* Llamada a la acción */}
      <Box sx={{ backgroundColor: '#c9aebc', py: { xs: 3, sm: 5, md: 6 }, px: { xs: 2, sm: 3 } }}>
        <Container maxWidth="md" sx={{ textAlign: 'center' }}>
          <Typography 
            variant="h3" 
            gutterBottom 
            sx={{ 
              color: '#602442',
              fontSize: { xs: '1.4rem', sm: '1.8rem', md: '2.5rem' },
              mb: { xs: 1.5, sm: 2, md: 3 },
              px: { xs: 1, sm: 0 }
            }} 
            fontWeight="bold"
          >
            ¿Listo para agendar tu cita?
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: '#602442', 
              mb: { xs: 2.5, sm: 3.5, md: 4 },
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
              px: { xs: 2, sm: 3 },
              lineHeight: 1.4
            }}
          >
            Contáctanos ahora y programa la atención que tu mascota necesita
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 1.5, sm: 2.5, md: 3 }, 
            justifyContent: 'center', 
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center'
          }}>
            <Button
              variant="contained"
              size="large"
              sx={{ 
                backgroundColor: '#602442', 
                '&:hover': { backgroundColor: '#a55e88' },
                px: { xs: 2.5, sm: 3.5, md: 4 },
                py: { xs: 1.2, sm: 1.5, md: 2 },
                borderRadius: 2,
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                fontWeight: 'bold',
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '280px', sm: 'none' },
                minWidth: { xs: '250px', sm: '200px' }
              }}
              startIcon={<WhatsAppIcon />}
              href="https://wa.me/573216103829?text=Hola,%20me%20gustaría%20agendar%20una%20cita"
              target="_blank"
            >
              Agendar por WhatsApp
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{ 
                borderColor: '#602442', 
                color: '#602442',
                '&:hover': { 
                  backgroundColor: '#602442',
                  color: 'white'
                },
                px: { xs: 2.5, sm: 3.5, md: 4 },
                py: { xs: 1.2, sm: 1.5, md: 2 },
                borderRadius: 2,
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                fontWeight: 'bold',
                borderWidth: 2,
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '280px', sm: 'none' },
                minWidth: { xs: '250px', sm: '200px' }
              }}
              startIcon={<PhoneIcon />}
              href="tel:+573216103829"
            >
              Llamar Ahora
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Footer simplificado */}
      <Box sx={{ backgroundColor: '#602442', color: 'white', py: { xs: 3, sm: 4 }, px: { xs: 2, sm: 3 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                mb: { xs: 1, sm: 2 },
                flexDirection: { xs: 'column', sm: 'row' },
                textAlign: { xs: 'center', sm: 'left' }
              }}>
                <img 
                  src="/logo192.png" 
                  alt="Belkysvet Logo" 
                  style={{ 
                    height: window.innerWidth < 600 ? '60px' : '80px', 
                    width: 'auto',
                    marginRight: window.innerWidth < 600 ? '0' : '20px',
                    marginBottom: window.innerWidth < 600 ? '10px' : '0'
                  }} 
                />
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center',
                  textAlign: { xs: 'center', sm: 'left' }
                }}>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      color: '#c46494', 
                      mb: 1, 
                      fontWeight: 'bold',
                      fontSize: { xs: '1.2rem', sm: '1.25rem' }
                    }}
                  >
                    Belkysveterinaria
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      mb: 0, 
                      lineHeight: 1.4,
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }}
                  >
                    Atención veterinaria profesional en la comodidad de tu hogar
                  </Typography>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mt: 1.5,
                    justifyContent: { xs: 'center', sm: 'flex-start' }
                  }}>
                    <LocationIcon sx={{ 
                      fontSize: { xs: '1rem', sm: '1.1rem' }, 
                      color: '#c46494',
                      mr: 0.5 
                    }} />
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontSize: { xs: '0.85rem', sm: '0.875rem' },
                        color: '#fcdcf4',
                        fontWeight: '500'
                      }}
                    >
                      Servicio a domicilio - Popayán, Cauca
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: { xs: 'center', md: 'flex-end' },
                justifyContent: 'center',
                height: '100%',
                textAlign: { xs: 'center', md: 'right' }
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  mb: 1,
                  justifyContent: { xs: 'center', md: 'flex-end' }
                }}>
                  <IconButton
                    component="a"
                    href="https://wa.me/573216103829?text=Hola,%20me%20gustaría%20agendar%20una%20cita"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: '#c46494',
                      '&:hover': {
                        color: '#fcdcf4',
                        transform: 'scale(1.1)'
                      },
                      transition: 'all 0.3s ease',
                      p: 1
                    }}
                  >
                    <WhatsAppIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.3rem' } }} />
                  </IconButton>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.9rem', sm: '1rem' }, 
                      fontWeight: '500',
                      ml: 1
                    }}
                  >
                    @belkys.veterinaria
                  </Typography>
                </Box>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  justifyContent: { xs: 'center', md: 'flex-end' },
                  mb: 1
                }}>
                  <IconButton
                    component="a"
                    href="mailto:belkys.veterinaria@gmail.com"
                    sx={{
                      color: '#c46494',
                      '&:hover': {
                        color: '#fcdcf4',
                        transform: 'scale(1.1)'
                      },
                      transition: 'all 0.3s ease',
                      p: 1
                    }}
                  >
                    <EmailIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.3rem' } }} />
                  </IconButton>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.9rem', sm: '1rem' }, 
                      fontWeight: '500',
                      ml: 1
                    }}
                  >
                    belkys.veterinaria@gmail.com
                  </Typography>
                </Box>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  justifyContent: { xs: 'center', md: 'flex-end' }
                }}>
                  <IconButton
                    component="a"
                    href="https://www.instagram.com/belkys.veterinaria/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: '#c46494',
                      '&:hover': {
                        color: '#fcdcf4',
                        transform: 'scale(1.1)'
                      },
                      transition: 'all 0.3s ease',
                      p: 1
                    }}
                  >
                    <InstagramIcon sx={{ fontSize: { xs: '1.5rem', sm: '1.8rem' } }} />
                  </IconButton>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: { xs: '0.9rem', sm: '1rem' }, 
                      fontWeight: '500',
                      ml: 1
                    }}
                  >
                    @belkys.veterinaria
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ 
            textAlign: 'center', 
            mt: { xs: 2, sm: 3 }, 
            pt: { xs: 2, sm: 3 }, 
            borderTop: '1px solid rgba(255,255,255,0.2)' 
          }}>
            <Typography 
              variant="body2" 
              sx={{ 
                opacity: 0.8,
                fontSize: { xs: '0.8rem', sm: '0.875rem' }
              }}
            >
              © 2025 Belkysveterinaria. Todos los derechos reservados.
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Botón flotante de WhatsApp */}
      <Fab
        color="success"
        aria-label="whatsapp"
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 20 },
          right: { xs: 16, sm: 20 },
          backgroundColor: '#c46494',
          '&:hover': { backgroundColor: '#a55e88' },
          width: { xs: 48, sm: 56 },
          height: { xs: 48, sm: 56 },
          zIndex: 1000
        }}
        href="https://wa.me/573216103829?text=Hola,%20me%20gustaría%20agendar%20una%20cita"
        target="_blank"
      >
        <WhatsAppIcon sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }} />
      </Fab>
    </Box>
  );
};

export default Servicios;
